"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getOrganisationSuggestions;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function OrganisationImage(_ref) {
  var url = _ref.url,
      organisationName = _ref.organisationName;
  return _react.default.createElement("img", {
    className: "organisation-basic-profile__parent-image",
    alt: "".concat(organisationName, "-logo"),
    src: url
  });
}

function getOrganisationSuggestions(organisations) {
  if (!organisations) {
    return [];
  }

  return organisations.map(function (organisation) {
    return {
      value: organisation.name,
      prefix: organisation.imageUrl ? _react.default.createElement(OrganisationImage, {
        url: organisation.imageUrl,
        organisationName: organisation.name
      }) : void 0,
      suffix: organisation.location ? _react.default.createElement("span", {
        className: "organisation-basic-profile__parent-location"
      }, "".concat(organisation.location.citySuburb, ", ").concat(organisation.location.country)) : void 0
    };
  });
}